/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "parts/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/6.jpg";
import team2 from "assets/images/22.jpg";
import team3 from "assets/images/16.jpg";
import team4 from "assets/images/35.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="info"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
            Why Choose Our Digital Marketing Services?
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
            At HP Tech Solutions, we go beyond traditional digital marketing—we are your strategic partner in building a strong online presence. Our mission is to deliver innovative, data-driven, and scalable marketing solutions that help businesses grow, engage their audiences, and thrive in a competitive digital landscape.

            With a team of experienced professionals, we combine expertise in SEO, social media, content marketing, and analytics to create tailored strategies that deliver measurable results. Whether you’re looking to increase brand awareness, drive traffic, or boost conversions, we offer a full suite of services designed to meet your unique marketing goals.
          </MKTypography>

          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Tailored Strategies"
                position={{ color: "info", label: "user-friendly" }}
                description="We design marketing strategies that are customized to meet your business goals and target audience."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Comprehensive Approach"
                position={{ color: "info", label: "threat detection" }}
                description="From content creation to analytics, we provide end-to-end digital marketing services that drive results."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Data-Driven Decisions"
                position={{ color: "info", label: "specific business goals" }}
                description="We use analytics to track, measure, and optimize campaigns for continuous improvement."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Proven Results"
                position={{ color: "info", label: "maximize ROI" }}
                description="Our experienced team helps businesses increase visibility, generate leads, and drive revenue through effective digital marketing."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
